import { Autocomplete, TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Controller, useFormContext } from "react-hook-form";

interface AutocompleteInterface {
  name: string;
  label: string;
  options: any;
  classNameTextField?: string;
  handleChangeAutoComplete?: (newValue: any) => void;
  [x: string]: any;
}

export const AutocompleteForm = ({
  name,
  label,
  options,
  classNameTextField,
  handleChangeAutoComplete,
  ...props
}: AutocompleteInterface) => {
  const { control, formState } = useFormContext();
  const errors = formState?.errors[name]
    ? formState.errors[name]?.message?.toString()
    : "";
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          value={value || null}
          onChange={(event: any, newValue: string | null) => {
            onChange(newValue);
            handleChangeAutoComplete && handleChangeAutoComplete(newValue);
          }}
          options={options}
          renderInput={(params) => (
            <TextField
              placeholder="SELECCIONE UNA OPCIÓN"
              className={classNameTextField}
              label={label}
              required={props?.required ?? false}
              error={formState.errors[name] ? true : false}
              helperText={errors}
              {...params}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {props.loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
              InputLabelProps={{ shrink: true }}
            />
          )}
          noOptionsText="Sin información disponible"
          {...props}
        />
      )}
      rules={props.rules}
    />
  );
};
